<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="resourceValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :error="errors.get('name')">
            </base-input>

            <base-input class="mb-3"
                :label="$t('common.url')"
                label-classes="form-control-label required"
                :placeholder="$t('common.url')"
                v-model="value.url"
                name="url"
                rules="required"
                :error="errors.get('url')">
            </base-input>

            <base-switch class="mb-3"
                v-model="value.confidential"
                :label="$t('resources.confidential')"
            ></base-switch>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
        },

        created() {
            this.errors.setValidator('resourceValidator', this)
        },

        methods: {
            
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
